import React from 'react'
import '@fontsource/mona-sans'
import { CartProvider } from './src/context/CartContext'
import { LoginPopupProvider } from './src/context/LoginPopupContext'
import ScrollIndicator from './src/components/ScrollIndicator'
import LoginPopup from './src/components/LoginPopup'

export const wrapRootElement = ({ element }) => {
  return (
    <CartProvider>
      <LoginPopupProvider>
        {element}
      </LoginPopupProvider>
    </CartProvider>
  )
}

export const wrapPageElement = ({ element }) => {
  return (
    <>
      {element}
      <LoginPopup />
      <ScrollIndicator />
    </>
  )
}

export const onClientEntry = () => {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'
  }
}

// Workaround for Gatsby 5 Head API bug where document.title is empty
// after React hydration despite title tag being present in DOM
const syncDocumentTitle = () => {
  const titleTag = document.querySelector('title[data-gatsby-head="true"]')
  if (titleTag && titleTag.textContent && document.title !== titleTag.textContent) {
    document.title = titleTag.textContent
  }
}

export const onRouteUpdate = () => {
  window.scrollTo(0, 0)
  setTimeout(() => window.scrollTo(0, 0), 10)
  setTimeout(() => window.scrollTo(0, 0), 100)
  setTimeout(() => window.scrollTo(0, 0), 300)

  // Sync document.title after Gatsby Head API has rendered
  setTimeout(syncDocumentTitle, 0)
  setTimeout(syncDocumentTitle, 100)
  setTimeout(syncDocumentTitle, 300)
}

export const onInitialClientRender = () => {
  // Sync title on initial page load after hydration
  setTimeout(syncDocumentTitle, 0)
  setTimeout(syncDocumentTitle, 100)
}

export const shouldUpdateScroll = () => {
  return [0, 0]
}
